import React, { useState, useEffect } from "react";
import { Card, Image } from "antd";
import http from "../../../../services/http";
import { useParams, Link } from "react-router-dom";
import { InvestorDetailSkeleton } from "../../../../components/page-skeleton";
import { toast } from "react-toastify";
import { addHttpsPrefix, replaceValueInDataSet } from "../../../../utils";
import InvestorActivities from "./activities";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import {
  DEFAULT_COMPANY_LOGO,
  ENTERPRISE_ROLE,
  IMAGE_HOST,
  INVESTOR_LOGO_HOST,
  LOGO_DEV_PUBLIC_KEY,
} from "../../../../constant";
import { useSelector } from "react-redux";
import AddLeadModal from "../../../../components/add-lead-modal";
import "./styles.scss";

function InvestorDetail() {
  // STATES
  const [isLoading, setLoading] = useState(false);
  const [investor, setInvestor] = useState(null);
  const [investorActivities, setInvestorActivities] = useState([]);
  const [addLeadPreview, setAddLeadPreview] = useState(false);

  // REDUX DATA
  const user = useSelector((state) => state.UserReducer.profile);
  const selectedCompany = useSelector((state) => state.CompanyReducer.selected_company);

  // CONST VALS
  const { id } = useParams();
  const history = useHistory();
  const isEnterpriseUser = user?.role === ENTERPRISE_ROLE;

  const goBack = () => {
    history.goBack();
  };

  // HELPERS
  const getInvestorDetail = async () => {
    setLoading(true);
    try {
      const { data } = await http.get(`investor/${id}`);
      setLoading(false);
      setInvestor(data?.investor);
      setInvestorActivities(data?.activities);
    } catch ({ response }) {
      setLoading(false);
      toast.error(response?.data?.error);
    }
  };

  useEffect(() => {
    getInvestorDetail();
  }, [id]);

  return (
    <div className="investpr-detail-wrapper">
      <h2 className="page-title">
        <button className="back-btn" onClick={goBack}>
          <ArrowLeftOutlined />
        </button>
        Investor Detail
      </h2>
      <div className="investor-detail">
        {isLoading && <InvestorDetailSkeleton />}
        {investor && (
          <>
            <Card className="basic-detail">
              <div className="title">
                <span className="thumb">
                  <Image
                    preview={false}
                    src={INVESTOR_LOGO_HOST + investor.url + `?token=${LOGO_DEV_PUBLIC_KEY}`}
                    fallback={IMAGE_HOST + DEFAULT_COMPANY_LOGO}
                    alt={investor?.company_name}
                  />
                </span>
                <h3>{investor?.company_name}</h3>
                {/* TODO: uncomment this when we restrict professional users from accessing enterprise features */}
                {/* {(selectedCompany?.id || !isEnterpriseUser) && ( */}
                {selectedCompany?.id && (
                  <button className="action-btn" onClick={() => setAddLeadPreview(true)}>
                    Add to Leads
                  </button>
                )}
              </div>
              <p className="description">
                {replaceValueInDataSet(investor?.description)}
              </p>
              <div className="other-detail">
                <div className="item url">
                  <h5>URL</h5>
                  <a href={addHttpsPrefix(investor?.url)} target="_blank">
                    <p>{investor?.url}</p>
                  </a>
                </div>
                <div className="item type">
                  <h5>Type</h5>
                  <p>{replaceValueInDataSet(investor?.type)}</p>
                </div>
                <div className="item type">
                  <h5>State</h5>
                  <p>{replaceValueInDataSet(investor?.us_state_full)}</p>
                </div>
                <div className="item type">
                  <h5>Country</h5>
                  <p>{replaceValueInDataSet(investor?.country)}</p>
                </div>
                <div className="item address">
                  <h5>Address</h5>
                  <p>{replaceValueInDataSet(investor?.hq_address)}</p>
                </div>
                <div className="item naics">
                  <h5>NAICS Industry</h5>
                  <p>{replaceValueInDataSet(investor?.naics_six_digit_industry)}</p>
                </div>
                <div className="item broad">
                  <h5>Broad Specialty</h5>
                  <p>{replaceValueInDataSet(investor?.broad_specialty)}</p>
                </div>
                <div className="item narrow">
                  <h5>Narrow Specialty</h5>
                  <p>{replaceValueInDataSet(investor?.narrow_specialty)}</p>
                </div>
                <div className="item investment">
                  <h5>
                    Typical Investment<i> (mm)</i>
                  </h5>
                  <p>{replaceValueInDataSet(investor?.typical_equity_investments)}</p>
                </div>
                <div className="item ebidta">
                  <h5>
                    Preferred EBTIDA<i> (mm)</i>
                  </h5>
                  <p>{replaceValueInDataSet(investor?.preferred_ebitda)}</p>
                </div>
                <div className="item ev">
                  <h5>
                    Preferred Enterprise Value (EV)<i> (mm)</i>
                  </h5>
                  <p>{replaceValueInDataSet(investor?.preferred_ev)}</p>
                </div>
                <div className="item revenue">
                  <h5>
                    Preferred Revenue<i> (mm)</i>
                  </h5>
                  <p>{replaceValueInDataSet(investor?.preferred_revenue)}</p>
                </div>
                <div className="item sector">
                  <h5>Sector Focus</h5>
                  <p>{replaceValueInDataSet(investor?.sector_focus)}</p>
                </div>
                <div className="item specialty">
                  <h5>Specialty Focus</h5>
                  <p>{replaceValueInDataSet(investor?.specialty_interests)}</p>
                </div>
              </div>
            </Card>
            {/* <InvestorActivities activities={investorActivities} /> */}
          </>
        )}
      </div>
      <AddLeadModal
        preview={addLeadPreview}
        title={investor?.company_name}
        data={investor}
        closeHandler={() => setAddLeadPreview(false)}
      />
    </div>
  );
}

export default InvestorDetail;
